import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { useAppSelector } from '../../../hooks/useAppSelector';
import * as clientSlice from '../../../data/client.slice';
import { useTranslation } from 'react-i18next';
import * as monitoringSlice from '../../../data/monitoring.slice';
import Exception from './TripDetailException/Exception';
import GlobalStyles from './TripDetailException/global';

const PREFIX = 'Passengers';

const classes = {
  container: `${PREFIX}-container`,
  title: `${PREFIX}-title`,
  divTrip: `${PREFIX}-divTrip`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(5),
    width: '100%',
  },
  [`& .${classes.title}`]: {
    fontFamily: 'Bitter',
    fontWeight: 700,
    fontSize: 30,
    marginBottom: theme.spacing(3),
  },
}));

export default function TripDetails() {
  const { t } = useTranslation('common');
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(clientSlice.fetchClientsAsync());
  }, []);

  return (
    <StyledBox className={classes.container}>
      <GlobalStyles />
      <Exception />
    </StyledBox>
  );
}
